import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=8a9e18e4&scoped=true&"
import script from "./Model.vue?vue&type=script&lang=js&"
export * from "./Model.vue?vue&type=script&lang=js&"
import style0 from "./Model.vue?vue&type=style&index=0&id=8a9e18e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9e18e4",
  null
  
)

export default component.exports